import React from "react";

/**
 * Simple masonry layout using CSS columns (matches the “old site” collage vibe).
 * - No rounded corners
 * - Uses break-inside to avoid splits
 */
export function MasonryGallery({
  items,
  columnsClassName = "columns-1 md:columns-2",
  gapClassName = "gap-6",
  onItemClick,
}) {
  return (
    <div className={`${columnsClassName} ${gapClassName}`}>
      {items.map((item, idx) => (
        <figure
          key={item.src}
          className="mb-6 break-inside-avoid bg-black"
          title={item.name}
        >
          <button
            type="button"
            className="w-full block bg-black cursor-zoom-in"
            onClick={() => onItemClick?.(idx)}
            aria-label={`Open ${item.alt ?? item.name}`}
          >
            <img
              src={item.src}
              alt={item.alt ?? item.name}
              loading="lazy"
              className="w-full h-auto block bg-black"
            />
          </button>
          <figcaption className="sr-only">{item.alt ?? item.name}</figcaption>
        </figure>
      ))}
    </div>
  );
}

